import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AlarisAuthService } from '@campaign-portal/components-library';

@Injectable({
	providedIn: 'root',
})
export class ResetGuardService {
	constructor(
		private readonly authService: AlarisAuthService,
		private readonly router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		this.authService.resetAuth();

		if (route.queryParams.key) {
			return true;
		}

		this.router.navigate(['']).then();
		return false;
	}
}

export const ResetGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
	inject(ResetGuardService).canActivate(route);
